/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `standard` - CASCO "STANDARD"
 * * `comfort` - CASCO "CONFORT"
 * * `fifty_fifty` - CASCO "50/50"
 * * `mini` - CASCO "MINI"
 */
export enum PackageEnum {
  STANDARD = 'standard',
  COMFORT = 'comfort',
  FIFTY_FIFTY = 'fifty_fifty',
  MINI = 'mini',
}
